import axios from 'axios';
import {URL} from '../../util/ambienteActions';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {montarURLFiltro} from '../../util/filtros';

export const TIPO_CENTRO_CUSTO_SELECIONADO = 'TIPO_CENTRO_CUSTO_SELECIONADO';
export const CADASTRAR_CENTRO_CUSTO = 'CADASTRAR_CENTRO_CUSTO';
export const ATUALIZAR_CENTRO_CUSTO = 'ATUALIZAR_CENTRO_CUSTO';
export const EXCLUIR_CENTRO_CUSTO = 'EXCLUIR_CENTRO_CUSTO';
export const BUSCAR_CENTROS_CUSTO = 'BUSCAR_CENTROS_CUSTO';
export const TIPOS_OCORRENCIA_CENTRO_CUSTO_CARREGADOS = 'TIPOS_OCORRENCIA_CENTRO_CUSTO_CARREGADOS';
export const CENTRO_CUSTO_SELECIONADO = 'CENTRO_CUSTO_SELECIONADO'

export function cadastrarCentroCusto(registro) {
    const url = `${URL}/centro-custo/cadastrar`;

    return dispatch => axios.post(url, registro, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_CENTRO_CUSTO,
            payload: response
        })
    );
}

export function atualizarCentroCusto(registro) {
    const url = `${URL}/centro-custo/atualizar`;

    return dispatch => axios.post(url, registro, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ATUALIZAR_CENTRO_CUSTO,
            payload: response
        })
    );
}


export function excluirCentroCusto (id, empresaId) {
    const url = `${URL}/centro-custo/${id}/empresa/${empresaId}/excluir`;

    return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: EXCLUIR_CENTRO_CUSTO,
            payload: response
        })
    );
}

export function buscarCentroCusto (empresaId, pagina, registrosPorPagina, filtros) {
    const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
    const url = `${URL}/centro-custo/empresa/${empresaId}${urlFiltros}`;

    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_CENTROS_CUSTO,
            payload: response.data,

        })
    )
}


export const buscarTiposOcorrenciaCentroCusto = () => dispatch => {
    return axios.get(`${URL}/centro-custo/tipos-ocorrencia`)
        .then(response => {
            dispatch({
                type: TIPOS_OCORRENCIA_CENTRO_CUSTO_CARREGADOS,
                payload: response.data
            });
        });
};

export function selecionaCentroCusto(registro) {
    return {
        type: TIPO_CENTRO_CUSTO_SELECIONADO,
        payload: registro
    };
}


